// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase'

var firebaseConfig = {
  apiKey: 'AIzaSyAK1vPkj--SCtT85GS1s49fY4e67N6yVgg',
  authDomain: 'legame-e45b7.firebaseapp.com',
  projectId: 'legame-e45b7',
  storageBucket: 'legame-e45b7.appspot.com',
  messagingSenderId: '481457207164',
  appId: '1:481457207164:web:12426888abbabb6cf656f9',
  measurementId: 'G-Q58HFZQ7H8'
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig)
firebase.analytics()

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js